import React, { useState, useRef } from "react";
import "../style/Importar.css"; // Asegúrate de que la ruta es correcta

const Importar = () => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedProviders, setSelectedProviders] = useState([]); // Proveedores para cada box
  const [processRunning, setProcessRunning] = useState(false);
  const [country, setCountry] = useState("");
  const [web, setWeb] = useState("");
  const [boxCount, setBoxCount] = useState(0);
  const [date, setDate] = useState("");
  const [successPopup, setSuccessPopup] = useState(false);
  const [errorPopup, setErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [failedFiles, setFailedFiles] = useState([]);

  // Proveedores para Dropi
  const dropiProviders = {
    Chile: [
      "Tropi Market","Importadora Btecno","Contraentregasantiago", "Intra Spa", "Lircay Spa", "Golden Prod", "Importadora Oferfly", "Viralify Import",
      "Mrv Spa", "Dropana", "Santiago Remate", "Marketfull Chile", "Zaga",
      "Nonstop Import Export Spa - La Serena", "Diamac 5", "De Todo Hogar",
      "Las Dalias Spa", "Liquidambar Spa", "Jlg Importadora Y Exportadora Ltda.",
      "Chamo Store", "Nibresma", "Wowi", "Chile Mayorista", "Rali Importaciones", "Compra Directa","", "Citotools", "Meibo.cl", "Importadora Rvg Spa", "Promotodo", "Impo Diamac", "Jp Ideas Spa", "Haz Tu Click Spa", "Citotools", "Uma Brands Spa Suplementos Y Salud", "Mindalife Nutrition", "Comercial T Y M", "Mw Chile", "Vidanova Suples", "Naturalboost" , "Espina Importaciones" , "Stock Listo"
    ],
    Paraguay: ["Adma Company", "Flexishop", "Zed Importados", "Jade Tech&glam", "Jade Tech&glam", "Jonasstore", "Bmf 77 Group", "Movi Cell", "Vortex Inc.", "Paris Import", "Panambi Hovy", "Divertchina", "Compras Py", "Anita Variedades", "X-press Shop", "Tengo Todo", "Ae Importadora", "Maria Rosa", "Kooltool", "Ejogua", "Yani Importaciones"], 
    Perú: [
      "El Gran Soy Yo", "Importadora El Mayorista PE", "Naerlinda",
      "Fabi Importaciones", "Baratisimo", "Evermont"
    ],
    Ecuador: ["El Mayorista Lab", "Distridrop Ecuador", "Laboratorio", "Nibresma EC", "Bodega De Belleza Ecommerce Int", "Imporshop", "Importadora El Mayorista", "Import Maidely", "Labb", "American Natural", "Equastore", "Yerbanova", "Suplementos Alimenticios Oscar", "Key Natural", "Laboratorio Naturalsplast", "Importadora Victoria", "Unmerco Ecuador", "Goldbox", "Articulos Creamer", "Laboratorio Nutri Gr - Healthy Human", "Belleza Pro", "Conectate", "Zamia Naturaleza Latina", "Saldos Ecuador", "Arte Mujer", "Comercializadora Laoz", "Xs", "Shibuya Ec"],

    Colombia: [
      "Soluciones", "Ads Lunar", "Konnen Service Sas", "1a Store",
      "Cómpralo En Casa", "Ggp", "Alanashop", "Kino Company",
      "Tecnohogarjs Sas", "Derocha Store Sas"
    ],
    Panamá: ["Inversiones Vhl"],
    México: [
      "Groupack", "Valentshop", "Dts Importadortesmx", "Angelica Chew",
      "Comercializadora Valtech", "Adma"
    ],
    España: ["Dropi", "Proveedor 16"],
  };

  // Proveedores para Easy Drop
  const easyDropProviders = {
    Chile: [
      "CATAMIMI SPA", "Comercializadora Liquida Chile", "COMPRALO SpA",
      "importadora BusNec", "Importadora EVE", "Kactus", "MEIBO.CL",
      "Mundo Rodados", "New Horizons", "Proveedor Chile", "Roma Romita",
      "Rudely", "Tudescuento Spa"
    ],
    Perú: ["Proveedor Perú Easy Drop 1"],
    Ecuador: ["Proveedor Ecuador Easy Drop 1"],
    Colombia: ["Proveedor Colombia Easy Drop 1"],
    Panamá: ["Proveedor Panamá Easy Drop 1"],
    México: ["Proveedor México Easy Drop 1"],
    España: ["Proveedor España Easy Drop 1"],
  };

  // Manejadores de los campos
  const handleDateChange = (e) => setDate(e.target.value);
  const handleCountryChange = (e) => setCountry(e.target.value);
  const handleWebChange = (e) => setWeb(e.target.value);
  const handleBoxCountChange = (e) => {
    setBoxCount(Number(e.target.value));
    // Opcional: Resetea los archivos y proveedores al cambiar la cantidad de boxes
    setSelectedFiles([]);
    setSelectedProviders([]);
  };

  // Manejar archivo para un box concreto
  const handleFileChange = (event, index) => {
    const fileList = event.target.files;
    if (fileList.length > 0) {
      const newFiles = [...selectedFiles];
      newFiles[index] = fileList[0];
      setSelectedFiles(newFiles);
    }
  };

  // Manejar proveedor en un box concreto
  const handleProviderSelect = (event, index) => {
    const chosenProvider = event.target.value;
    const newProviders = [...selectedProviders];
    newProviders[index] = chosenProvider;
    setSelectedProviders(newProviders);
  };

  // Seleccionar varios archivos con el botón "Seleccionar Archivos"
  const handleMultipleFiles = (event) => {
    const files = Array.from(event.target.files);
    // Ordenar si es necesario
    files.sort((a, b) => a.lastModified - b.lastModified);
    setSelectedFiles(files);
  };

  // Generar boxes dinámicamente
  const generateBoxes = () => {
    const boxes = [];
    for (let i = 0; i < boxCount; i++) {
      const fileName = selectedFiles[i] ? selectedFiles[i].name : "No se ha seleccionado ningún archivo";
      const providerValue = selectedProviders[i] || "";

      boxes.push(
        <div key={i} className="box">
          <p>{fileName}</p>
          <input
            type="file"
            id={`file-input-${i}`}
            accept=".xlsx"
            style={{ display: "none" }}
            onChange={(e) => handleFileChange(e, i)}
          />
          <button type="button" onClick={() => document.getElementById(`file-input-${i}`).click()}>
            Examinar
          </button>

          <select value={providerValue} onChange={(e) => handleProviderSelect(e, i)}>
            <option value="">Seleccionar proveedor</option>
            {(web === "Dropi"
              ? dropiProviders[country]
              : easyDropProviders[country])?.map((prov, idx) => (
              <option key={idx} value={prov}>
                {prov}
              </option>
            ))}
          </select>
        </div>
      );
    }
    return boxes;
  };

  // Enviar formulario
  const submitForm = async () => {
    if (!date || !country || !web || boxCount === 0) {
      alert("Por favor, completa todos los campos antes de enviar.");
      return;
    }

    // Validar que todos los archivos y proveedores estén seleccionados
    for (let i = 0; i < boxCount; i++) {
      if (!selectedFiles[i] || !selectedProviders[i]) {
        alert(`Por favor, selecciona un archivo y un proveedor para el box ${i + 1}.`);
        return;
      }
    }

    const formData = new FormData();
    formData.append("date", date);
    formData.append("country", country);
    formData.append("web", web);

    // Agregar cada archivo y su proveedor
    selectedFiles.forEach((file, index) => {
      formData.append("files[]", file);
      formData.append("providers[]", selectedProviders[index] || "");
    });

    try {
      // 1) Enviar los archivos a upload0.php
      const uploadResponse = await fetch("https://marketbusters.pro/importacion/upload0.php", {
        method: "POST",
        body: formData,
      });

      const uploadResult = await uploadResponse.json();

      if (uploadResponse.ok) {
        console.log("Datos enviados a upload0.php:", uploadResult);

        // Asumiendo que uploadResult tiene 'success' y 'errors'
        setUploadedFiles(uploadResult.success || []);
        setFailedFiles(uploadResult.errors || []);
        setSuccessPopup(true); // Mostrar popup con resultados

        // 2) Llamar a obtener_informe.php inmediatamente después
        const informeResponse = await fetch("https://marketbusters.pro/informes/obtener_informe.php", {
          method: "GET",
        });

        if (informeResponse.ok) {
          // Supongamos que obtener_informe.php retorna texto
          const informeText = await informeResponse.text();
          console.log("Informe generado:", informeText);
          // Puedes manejar el informe según tus necesidades
        } else {
          console.error("Error al generar el informe. Código de respuesta:", informeResponse.status);
          setErrorMessage(`Error al generar el informe. Código: ${informeResponse.status}`);
          setErrorPopup(true);
        }
      } else {
        console.error("Error en el procesamiento:", uploadResult.errors);
        setErrorMessage(uploadResult.errors?.join("\n") || "Error en la subida.");
        setErrorPopup(true);
      }
    } catch (error) {
      console.error("Error al enviar los datos o generar el informe:", error);
      setErrorMessage("Error al enviar los datos: " + error.message);
      setErrorPopup(true);
    }
  };

  // Función para limpiar el formulario
  const clearForm = () => {
    setSelectedFiles([]);
    setSelectedProviders([]);
    setCountry("");
    setWeb("");
    setBoxCount(0);
    setDate("");
    setUploadedFiles([]);
    setFailedFiles([]);
  };

  // Funciones para manejar popups
  const showErrorPopup = (message) => {
    setErrorMessage(message);
    setErrorPopup(true);
  };

  const showSuccessPopup = (message) => {
    setSuccessPopup(true);
  };

  // Función para iniciar o detener el proceso
  const handleProcess = async () => {
    if (processRunning) {
      // Confirmar si desea detener el proceso
      const confirmStop = window.confirm("¿Quieres detener la ejecución del script?");
      if (confirmStop) {
        await stopProcess();
      }
    } else {
      await startProcess();
    }
  };

  // Función para iniciar el proceso
  const startProcess = async () => {
    try {
      // 1) Limpiar los logs
      const clearLogResponse = await fetch("https://marketbusters.pro/chart/clear_log.php", {
        method: "GET",
      });

      const clearLogData = await clearLogResponse.json();

      if (clearLogData.status === "success") {
        console.log("Log cleared");

        setProcessRunning(true);
        alert("El cálculo de variaciones ha comenzado en segundo plano.");

        // Abrir la vista de logs en una nueva pestaña
        window.open("https://marketbusters.pro/chart/view_log.html", "_blank");

        // 2) Iniciar el proceso de cálculo
        const processResponse = await fetch("https://marketbusters.pro/chart/process.php", {
          method: "GET",
        });

        if (processResponse.ok) {
          console.log("El cálculo de variaciones ha comenzado.");
        } else {
          console.error("Error al iniciar el cálculo de variaciones.");
          showErrorPopup("Error al iniciar el cálculo de variaciones.");
          setProcessRunning(false);
        }
      } else {
        console.error("Error clearing log:", clearLogData.message);
        showErrorPopup(`Error al limpiar los logs: ${clearLogData.message}`);
      }
    } catch (error) {
      console.error("Error al iniciar el proceso:", error);
      showErrorPopup("Error al iniciar el proceso: " + error.message);
    }
  };

  // Función para detener el proceso
  const stopProcess = async () => {
    try {
      const stopResponse = await fetch("https://marketbusters.pro/chart/create_stop_file.php", {
        method: "GET",
      });

      const stopData = await stopResponse.text();

      alert("Proceso detenido");
      console.log(stopData);
      setProcessRunning(false);
    } catch (error) {
      console.error("Error al detener el proceso:", error);
      showErrorPopup("Error al detener el proceso: " + error.message);
    }
  };

  return (
    <div className="container">
      <div className="form-section">
        {/* Fecha */}
        <div className="form-group">
          <label htmlFor="date-input">Fecha:</label>
          <input
            id="date-input"
            type="date"
            value={date}
            onChange={handleDateChange}
          />
        </div>

        {/* Web: Dropi / Easy Drop */}
        <div className="form-group">
          <label>Selecciona una opción:</label>
          <div style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}>
            <div style={{ marginRight: "15px" }}>
              <input
                type="radio"
                id="dropi"
                name="web"
                value="Dropi"
                checked={web === "Dropi"}
                onChange={handleWebChange}
              />
              <label htmlFor="dropi">Dropi</label>
            </div>
            <div style={{ marginLeft: "15px" }}>
              <input
                type="radio"
                id="easydrop"
                name="web"
                value="Easy Drop"
                checked={web === "Easy Drop"}
                onChange={handleWebChange}
              />
              <label htmlFor="easydrop">Easy Drop</label>
            </div>
          </div>
        </div>

        {/* País */}
        <div className="form-group">
          <label htmlFor="country-select">País:</label>
          <select
            id="country-select"
            value={country}
            onChange={handleCountryChange}
          >
            <option value="">Seleccionar país</option>
            <option value="Chile">Chile</option>
            <option value="Paraguay">Paraguay</option>
            <option value="Perú">Perú</option>
            <option value="Ecuador">Ecuador</option>
            <option value="Colombia">Colombia</option>
            <option value="Panamá">Panamá</option>
            <option value="México">México</option>
            <option value="España">España</option>
          </select>
        </div>

        {/* N° Boxes */}
        <div className="form-group">
          <label htmlFor="box-count-select">N° de boxes:</label>
          <select
            id="box-count-select"
            value={boxCount}
            onChange={handleBoxCountChange}
          >
            <option value="">Seleccionar cantidad de boxes</option>
            {Array.from({ length: 30 }, (_, i) => i + 1).map((num) => (
              <option key={num} value={num}>
                {num}
              </option>
            ))}
          </select>
        </div>

        {/* Botón Enviar a BD */}
        <div className="form-group">
          <button onClick={submitForm} className="submit-button">
            Enviar a Base de Datos
          </button>
        </div>

        {/* Botón Seleccionar Archivos (múltiples) */}
        <div className="form-group">
          <button
            type="button"
            onClick={() => document.getElementById("multiple-file-input").click()}
          >
            Seleccionar Archivos
          </button>
          <input
            id="multiple-file-input"
            type="file"
            accept=".xlsx"
            multiple
            style={{ display: "none" }}
            onChange={handleMultipleFiles}
          />
        </div>

        {/* Botón Cálculo de Variaciones */}
        <div className="form-group">
          <button onClick={handleProcess} className="process-button">
            {processRunning ? "Detener Cálculo de Variaciones" : "Ejecutar Cálculo de Variaciones"}
          </button>
        </div>

        {/* Botón Limpiar Datos */}
        <div className="form-group">
          <button onClick={clearForm} className="clear-button">
            Limpiar Datos
          </button>
        </div>
      </div>

      {/* Aquí se generan los boxes dinámicamente */}
      <div className="box-container">{generateBoxes()}</div>

      {/* Popup de resultados de subida */}
      {(uploadedFiles.length > 0 || failedFiles.length > 0) && (
        <div id="resultPopup" className="popup">
          <h3>Resultado de la Subida</h3>

          {uploadedFiles.length > 0 && (
            <div>
              <h4>Archivos Subidos Correctamente:</h4>
              <ul>
                {uploadedFiles.map((file, index) => (
                  <li key={index}>{file}</li>
                ))}
              </ul>
            </div>
          )}

          {failedFiles.length > 0 && (
            <div>
              <h4>Archivos que Fallaron al Subir:</h4>
              <ul>
                {failedFiles.map((file, index) => (
                  <li key={index}>{file}</li>
                ))}
              </ul>
            </div>
          )}

          <button onClick={() => { setUploadedFiles([]); setFailedFiles([]); setSuccessPopup(false); }}>
            Cerrar
          </button>
        </div>
      )}

      {/* Popup de error (si aún deseas mantenerlo para otros errores) */}
      {errorPopup && (
        <div id="errorPopup" className="popup">
          <p>{errorMessage}</p>
          <button onClick={() => setErrorPopup(false)}>Cerrar</button>
        </div>
      )}
    </div>
  );
};

export default Importar;